import React, { useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import {
  Container,
  Menu,
  MenuItem,
  Content,
  Wrapper,
  FilterContainer,
} from './UI.styled';
import Drafts from '../DraftsPage';
import SavedTemplates from '../SavedTemplatesPage';
import SharedTemplates from '../SharedTemplatesPage';
import SavedAudiences from '../SavedAudiencesPage';
import MediaManager from '../MediaManager';
import {
  AUDIENCES_TAB,
  SHARED_TEMPLATES_TAB,
  SAVED_TEMPLATES_TAB,
  DRAFTS_TAB,
  MEDIA_MANAGER_TAB,
  ACTIVE,
  DATE,
} from '../_utils/constants';
import FilterCardsSelectDropdown from '../_Filters/FilterCardsSelectDropdown';
import SortCardsSelectDropdown from '../_Filters/SortCardsSelectDropdown';
import CardsSearch from './Search';
import {
  getDrafts,
  getOrgAudiences,
  getUserTemplates,
  getTemplates,
} from '../../../../redux/services';

const Tabs = ({ content }) => {
  const history = useHistory();
  const location = useLocation();
  const [activeSortByValue, setSortByValue] = useState(DATE.value);
  const [activeFilter, setActiveFilter] = useState(ACTIVE.value);
  const [cardsBySearch, setCardsBySearch] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [loadingCardsBySearch, setLoadingCardsBySearch] = useState(false);
  const [hasMoreSearchCardsToLoad, setHasMoreSearchCardsToLoad] =
    useState(false);
  const loadSearchCardsRef = useRef(null);
  const {
    tab: currentTab,
    apply,
    draft,
    campaignId,
    stageId,
  } = queryString.parse(location.search);

  const handleTabClick = tab => {
    const params = new URLSearchParams();
    if (tab) params.set('tab', tab);
    if (apply) params.set('apply', '1');
    if (draft) params.set('draft', draft);
    // Preserve automated campaigns context params
    if (campaignId) params.set('campaignId', campaignId);
    if (stageId) params.set('stageId', stageId);

    history.replace(`/dashboard/drafts?${params.toString()}`);
    setSortByValue(DATE.value);
    setActiveFilter(ACTIVE.value);
    setCardsBySearch([]);
    setSearchValue('');
  };

  const renderContent = () => {
    switch (currentTab) {
      case SAVED_TEMPLATES_TAB:
        return (
          <SavedTemplates
            activeSortByValue={activeSortByValue}
            activeFilter={activeFilter}
            cardsBySearch={cardsBySearch}
            loadingCardsBySearch={loadingCardsBySearch}
            searchValue={searchValue}
            hasMoreSearchCardsToLoad={hasMoreSearchCardsToLoad}
            loadSearchCardsRef={loadSearchCardsRef}
          />
        );
      case SHARED_TEMPLATES_TAB:
        return (
          <SharedTemplates
            cardsBySearch={cardsBySearch}
            loadingCardsBySearch={loadingCardsBySearch}
            searchValue={searchValue}
            hasMoreSearchCardsToLoad={hasMoreSearchCardsToLoad}
            loadSearchCardsRef={loadSearchCardsRef}
            setCardsBySearch={setCardsBySearch}
          />
        );
      case AUDIENCES_TAB:
        return (
          <SavedAudiences
            activeSortByValue={activeSortByValue}
            activeFilter={activeFilter}
            cardsBySearch={cardsBySearch}
            loadingCardsBySearch={loadingCardsBySearch}
            searchValue={searchValue}
            hasMoreSearchCardsToLoad={hasMoreSearchCardsToLoad}
            loadSearchCardsRef={loadSearchCardsRef}
          />
        );
      case MEDIA_MANAGER_TAB:
        return <MediaManager />;
      default:
        return (
          <Drafts
            activeSortByValue={activeSortByValue}
            activeFilter={activeFilter}
            cardsBySearch={cardsBySearch}
            loadingCardsBySearch={loadingCardsBySearch}
            searchValue={searchValue}
            hasMoreSearchCardsToLoad={hasMoreSearchCardsToLoad}
            loadSearchCardsRef={loadSearchCardsRef}
          />
        );
    }
  };

  const getFilterDropdowns = () => {
    const { sort, filter } = content.find(({ tab }) => {
      return tab === currentTab;
    });
    const isSortByValueAvailable = !!sort;
    const isFilterByValueAvailable = !!filter;

    return (
      <>
        {isSortByValueAvailable && (
          <SortCardsSelectDropdown
            sortBy={sort}
            activeSortByValue={activeSortByValue}
            setSortByValue={setSortByValue}
          />
        )}
        {isFilterByValueAvailable && (
          <FilterCardsSelectDropdown
            filterBy={filter}
            activeFilter={activeFilter}
            setActiveFilter={setActiveFilter}
          />
        )}
      </>
    );
  };

  const correctAPI = {
    [SAVED_TEMPLATES_TAB]: getUserTemplates,
    [SHARED_TEMPLATES_TAB]: getTemplates,
    [AUDIENCES_TAB]: getOrgAudiences,
    [DRAFTS_TAB]: getDrafts,
  };

  return (
    <Container>
      <Wrapper>
        <Menu>
          {content.map(({ menuItemName, tab }) => (
            <MenuItem
              key={menuItemName}
              onClick={() => handleTabClick(tab)}
              className={tab === currentTab ? 'active' : ''}
            >
              {menuItemName}
            </MenuItem>
          ))}
        </Menu>
        <FilterContainer>
          <CardsSearch
            setCards={setCardsBySearch}
            cards={cardsBySearch}
            setLoading={setLoadingCardsBySearch}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            getCards={correctAPI[currentTab || DRAFTS_TAB]}
            setHasMoreSearchCardsToLoad={setHasMoreSearchCardsToLoad}
            loadSearchCardsRef={loadSearchCardsRef}
            activeSortByValue={activeSortByValue}
            activeFilter={activeFilter}
          />
          {getFilterDropdowns()}
        </FilterContainer>
      </Wrapper>
      <Content>{renderContent()}</Content>
    </Container>
  );
};

export default Tabs;
